var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 499.2 499.2",
    style: {
      enableBackground: "new 0 0 499.2 499.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C4C4"
    },
    d: "M457.6,497.6v-59.2c0-44-35.2-76.8-79.2-76.8H120.8c-44,0-79.2,32-79.2,76.8v59.2H457.6z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#08B8BC"
    },
    points: "41.6,441.6 41.6,497.6 457.6,497.6 457.6,441.6 "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#36FFF5"
    },
    cx: 249.6,
    cy: 374.4,
    rx: 59.2,
    ry: 52.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5B5B"
    },
    d: "M313.6,352.8c0,34.4-25.6,60.8-62.4,61.6l0,0c-34.4,0-65.6-27.2-65.6-61.6V320 c0-34.4,28-62.4,62.4-62.4h4c34.4,0,62.4,28,62.4,62.4v32.8H313.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3F3F"
    },
    d: "M250.4,260L250.4,260c34.4,0,63.2,28,63.2,62.4v30.4c0,34.4-24.8,60.8-62.4,61.6l0,0"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#686868"
    },
    points: "313.6,337.6 313.6,329.6 185.6,329.6 185.6,337.6 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B6382"
    },
    d: "M253.6,69.6c0,2.4-1.6,4-4,4l0,0c-2.4,0-4-1.6-4-4v-64c0-2.4,1.6-4,4-4l0,0c2.4,0,4,1.6,4,4V69.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M249.6,1.6L249.6,1.6c3.2,0,4,2.4,4,4.8v63.2c0,3.2-0.8,4-4,4l0,0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.6,
    y: 65.6,
    style: {
      fill: "#F45683"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E2336D"
    },
    points: "233.6,65.6 265.6,65.6 265.6,97.6 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.6,
    y: 69.6,
    style: {
      fill: "#00E2E2"
    },
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15819E"
    },
    points: "245.6,14.4 253.6,14.4 253.6,12 245.6,12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15819E"
    },
    points: "245.6,24.8 253.6,24.8 253.6,22.4 245.6,22.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15819E"
    },
    points: "245.6,35.2 253.6,35.2 253.6,32.8 245.6,32.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15819E"
    },
    points: "245.6,44.8 253.6,44.8 253.6,42.4 245.6,42.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15819E"
    },
    points: "245.6,55.2 253.6,55.2 253.6,52.8 245.6,52.8  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B6382"
    },
    d: "M137.6,136.8c0,9.6-7.2,16.8-16.8,16.8H98.4c-9.6,0-16.8-7.2-16.8-16.8V98.4 c0-9.6,7.2-16.8,16.8-16.8h22.4c9.6,0,16.8,7.2,16.8,16.8V136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M97.6,81.6H120c9.6,0,17.6,6.4,17.6,16v36c0,9.6-8.8,20-17.6,20H97.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B6382"
    },
    d: "M409.6,136.8c0,9.6-7.2,16.8-16.8,16.8h-22.4c-9.6,0-16.8-7.2-16.8-16.8V98.4 c0-9.6,7.2-16.8,16.8-16.8h22.4c9.6,0,16.8,7.2,16.8,16.8V136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M377.6,81.6h16c9.6,0,16,6.4,16,16v36c0,9.6-6.4,20-16,20h-16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00E2E2"
    },
    d: "M483.2,240c0,44.8-60.8,81.6-105.6,97.6h-256C76.8,321.6,16,284.8,16,240L0,172.8 C0,128,36.8,89.6,82.4,89.6h335.2c44.8,0,81.6,38.4,81.6,83.2L483.2,240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C4C4"
    },
    d: "M499.2,174.4l-16,65.6c0,44.8-60.8,81.6-105.6,97.6h-256C29.6,307.2,16,284.8,16,240L0,174.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#08B8BC"
    },
    d: "M483.2,240c0,44.8-60.8,81.6-105.6,97.6h-256C20,305.6,16,276,16,240"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0B6382"
    },
    cx: 109.6,
    cy: 205.6,
    r: 81.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.2,
      fill: "#727272",
      enableBackground: "new"
    },
    cx: 109.6,
    cy: 214.4,
    r: 81.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M109.6,124c44.8,0,81.6,36.8,81.6,81.6s-36.8,81.6-81.6,81.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFAF5"
    },
    cx: 109.6,
    cy: 205.6,
    r: 55.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFAF5"
    },
    cx: 109.6,
    cy: 205.6,
    r: 55.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEBE8"
    },
    d: "M71.2,166.4c21.6-21.6,56.8-21.6,78.4,0s21.6,56.8,0,78.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCAC8"
    },
    d: "M109.6,164.8c29.6,0,53.6,14.4,55.2,44c0-0.8,0-2.4,0-3.2c0-30.4-24.8-55.2-55.2-55.2 s-55.2,24.8-55.2,55.2c0,0.8,0,2.4,0,3.2C56.8,180,80.8,164.8,109.6,164.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CCCAC8"
    },
    cx: 92.8,
    cy: 136.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CCCAC8"
    },
    cx: 109.6,
    cy: 136.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CCCAC8"
    },
    cx: 127.2,
    cy: 136.8,
    r: 3.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272"
    },
    d: "M120.8,205.6c0,5.6-4.8,10.4-10.4,10.4s-10.4-4.8-10.4-10.4c0-5.6,4.8-10.4,10.4-10.4 S120.8,200,120.8,205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3F3F"
    },
    d: "M109.6,195.2c5.6,0,10.4,4.8,10.4,10.4c0,5.6-4.8,10.4-10.4,10.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFAF5"
    },
    cx: 105.6,
    cy: 200.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFAF5"
    },
    cx: 114.4,
    cy: 210.4,
    r: 1.6
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0B6382"
    },
    cx: 384,
    cy: 205.6,
    r: 81.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.2,
      fill: "#727272",
      enableBackground: "new"
    },
    cx: 384,
    cy: 214.4,
    r: 81.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M384,124c44.8,0,81.6,36.8,81.6,81.6s-36.8,81.6-81.6,81.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFAF5"
    },
    cx: 384,
    cy: 205.6,
    r: 55.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFAF5"
    },
    cx: 384,
    cy: 205.6,
    r: 55.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEBE8"
    },
    d: "M344.8,166.4c21.6-21.6,56.8-21.6,78.4,0s21.6,56.8,0,78.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCAC8"
    },
    d: "M384,164.8c29.6,0,53.6,14.4,55.2,44c0-0.8,0-2.4,0-3.2c0-30.4-24.8-55.2-55.2-55.2 s-55.2,24.8-55.2,55.2c0,0.8,0,2.4,0,3.2C330.4,180,354.4,164.8,384,164.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CCCAC8"
    },
    cx: 367.2,
    cy: 136.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CCCAC8"
    },
    cx: 384,
    cy: 136.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CCCAC8"
    },
    cx: 400.8,
    cy: 136.8,
    r: 3.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272"
    },
    d: "M394.4,205.6c0,5.6-4.8,10.4-10.4,10.4s-10.4-4.8-10.4-10.4c0-5.6,4.8-10.4,10.4-10.4 S394.4,200,394.4,205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F3F3F"
    },
    d: "M384,195.2c5.6,0,10.4,4.8,10.4,10.4c0,5.6-4.8,10.4-10.4,10.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFAF5"
    },
    cx: 380,
    cy: 200.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFAF5"
    },
    cx: 388,
    cy: 210.4,
    r: 1.6
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36FFF5"
    },
    d: "M104,105.6L104,105.6c0-4,3.2-8,7.2-8h277.6c4,0,7.2,4,7.2,7.2l0,0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.6,
    y: 345.6,
    style: {
      fill: "#686868"
    },
    width: 128,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.6,
    y: 417.6,
    style: {
      fill: "#A0D827"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFF23B"
    },
    points: "105.6,433.6 81.6,444.8 81.6,417.6 105.6,417.6 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.6,
    y: 417.6,
    style: {
      fill: "#F2AE16"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCC4D"
    },
    points: "145.6,433.6 121.6,444.8 121.6,417.6 145.6,417.6 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36FFF5"
    },
    d: "M409.6,421.6c0,2.4-1.6,4-4,4h-56c-2.4,0-4-1.6-4-4l0,0c0-2.4,1.6-4,4-4h56 C408,417.6,409.6,419.2,409.6,421.6L409.6,421.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36FFF5"
    },
    d: "M409.6,445.6c0,2.4-1.6,4-4,4h-56c-2.4,0-4-1.6-4-4l0,0c0-2.4,1.6-4,4-4h56 C408,441.6,409.6,443.2,409.6,445.6L409.6,445.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36FFF5"
    },
    d: "M409.6,469.6c0,2.4-1.6,4-4,4h-56c-2.4,0-4-1.6-4-4l0,0c0-2.4,1.6-4,4-4h56 C408,465.6,409.6,467.2,409.6,469.6L409.6,469.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F45683"
    },
    points: "297.6,255.2 249.6,303.2 201.6,255.2 249.6,270.4 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2336D"
    },
    points: "297.6,255.2 249.6,303.2 201.6,255.2 249.6,284 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F45683"
    },
    cx: 249.6,
    cy: 116,
    r: 15.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2336D"
    },
    d: "M264.8,116c0,8-6.4,15.2-15.2,15.2s-15.2-6.4-15.2-15.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2336D"
    },
    d: "M252,233.6c0,0.8-0.8,2.4-2.4,2.4l0,0c-0.8,0-2.4-0.8-2.4-2.4V128.8c0-0.8,0.8-2.4,2.4-2.4l0,0 c0.8,0,2.4,0.8,2.4,2.4V233.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7519c860c0e09c89dcdba418c638e059.svg";
export { ForwardRef as ReactComponent };